import { useAtom } from "jotai"
import { signIn } from "next-auth/react"
import { useForm } from "react-hook-form"

import { ActionButton } from "components/Button"
import { ErrorMessage, Input } from "components/forms/FormElements"
import { signInAlertAtom, signInErrors } from "pages/sign-in"

const SignInCredentials: React.FC = () => {
  const rhf = useForm<{
    email: string
    password: string
  }>({
    shouldUnregister: true
  })

  const [, setSignInAlert] = useAtom(signInAlertAtom)

  return (
    <form
      onSubmit={rhf.handleSubmit(async () => {
        // sign in returns a promise when using redirect: false
        // See https://next-auth.js.org/getting-started/client#using-the-redirect-false-option
        const credentialsRes = await signIn("credentials", {
          redirect: false,
          email: rhf.getValues("email"),
          password: rhf.getValues("password")
        })

        if (credentialsRes?.error) {
          setSignInAlert({
            content: signInErrors[credentialsRes.error as "Default"],
            show: true,
            variant: "error"
          })
        }
      })}
    >
      <div>
        <Input
          type="text"
          autoComplete="off"
          showRequired
          {...rhf.register("email", { required: true })}
        />
        {rhf.formState.errors.email && (
          <ErrorMessage>Please enter your email address</ErrorMessage>
        )}
      </div>
      <div>
        <Input
          type="password"
          autoComplete="off"
          showRequired
          {...rhf.register("password", { required: true })}
        />
        {rhf.formState.errors.password && (
          <ErrorMessage>Please enter your password</ErrorMessage>
        )}
      </div>
      <ActionButton
        kind="submit"
        isLoading={rhf.formState.isSubmitting}
        loadingText="Signing in"
      >
        Sign in
      </ActionButton>
    </form>
  )
}

export default SignInCredentials
